export default {
    props: {
        label: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        rawLabel: Boolean,
    },

    computed: {
        labelText() {
            if (!this.label) return null
            return this.rawLabel ? this.label : this.$t(this.label)
        },
    },
}
